import styled from '@emotion/styled'
import { Link } from '@mui/material'

/**
 * Style the MUI Link component so that it behaves more like a button.
 * Avoids the need to pass link props all the way through the affected component(s).
 *
 * Usage:
 * When used as a child in a flex container, it takes up the sibling's height which is problematic.
 * The solution is to put alignItems="flex-start" on the parent flex container.
 */
export const StyledLink = styled(Link)`
  text-decoration: none;

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    color: white;
    text-decoration: none;
  }
`
